export default "__VITE_ASSET__408c1cf2__"